@if (!showManageFilters) {
  <div class="filter-main-container">
    <div class="header">
      <div fxLayout="row">
        <button
          class="left-drawer-toggle"
          mat-icon-button
          matTooltip="Hide Quick Filters"
          matTooltipShowDelay="500"
          (click)="toggleQuickFiltersClick()"
          aria-label="Toggle visibility of quick filters"
        >
          @if (leftDrawerOpen) {
            <mat-icon>chevron_left</mat-icon>
          }
          @if (!leftDrawerOpen) {
            <mat-icon>chevron_right</mat-icon>
          }
        </button>
        <h3 [fxHide]="!leftDrawerOpen">Quick Filters</h3>
      </div>
      <button
        [disabled]="filterService?.selectedView?.isAdvanced"
        [fxHide]="!leftDrawerOpen"
        mat-icon-button
        [matMenuTriggerFor]="menu"
        matTooltip="More actions"
        aria-label="More actions"
        matTooltipShowDelay="500"
      >
        <mat-icon>more_vert</mat-icon>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="showManageFilters = true">
            <span>Customize Quick Filters</span>
          </button>
        </mat-menu>
      </button>
    </div>
    <mat-divider [fxHide]="!leftDrawerOpen"></mat-divider>
    <div class="filter-content" [fxHide]="!leftDrawerOpen">
      @if (filterService?.selectedView?.isAdvanced) {
        <p class="p-1">
          The quick filter is not available in advanced filter mode.
        </p>
      }
      @if (!filterService?.selectedView?.isAdvanced) {
        <ng-scrollbar>
          <div class="filters">
            @for (
              filterItem of filterItems | orderBy: 'rank';
              track filterItem
            ) {
              <quick-odata-filter-item
                [filterItem]="filterItem"
                (addFilter)="onAdd($event)"
                (removeFilter)="onRemove($event)"
              ></quick-odata-filter-item>
            }
            @if (filterItems.length) {
              <button
                class="show-button"
                color="primary"
                mat-button
                (click)="showAllFilters.emit()"
              >
                View All Filters
              </button>
            }
          </div>
        </ng-scrollbar>
      }
    </div>
  </div>
}
@if (showManageFilters) {
  <manage-qiuck-odata-filters
    [filters]="filterCollection"
    [quickFilters]="filterItems"
    (cancel)="showManageFilters = false"
    (apply)="applyManageFilterResult($event)"
  ></manage-qiuck-odata-filters>
}
